import { SET_PROMPTER_FONT_SIZE } from '../actionConstants';

export const setPrompterFontSizeAction = (payload) => {
  return {
    type: SET_PROMPTER_FONT_SIZE,
    payload,
  };
};
